import React, { createContext } from 'react';

// Create a context for app-wide state
export const AppContext = createContext(null);

/**
 * AppContextProvider - Provides access to app-wide state
 * This allows components to access and update the app state regardless of their position in the component tree
 */
export const AppContextProvider = ({ children, value }) => {
  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};
